import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { FeatureList, FeatureListItem } from 'telia-front-react';

interface AccessibilityIconsProps {
  accessibilityInformation: string[];
}

export const AccessibilityIcons = observer((props: AccessibilityIconsProps): React.ReactElement => {
  const { accessibilityInformation } = props;
  const { translate } = React.useContext(TranslationsContext);

  return (
    <FeatureList>
      {accessibilityInformation?.map((item, index) => {
        return <FeatureListItem key={index} icon={translate(`branchDetails.icon.${item}`)} children={<p>{translate(`branchDetails.children.${item}`)}</p>} />;
      })}
    </FeatureList>
  );
});
